/**
 * URBAN TRENDZ - Main JavaScript
 * Handles animations, interactions, and conversion optimization
 */

(function() {
  'use strict';

  // =============================================
  // Intersection Observer for Animations
  // =============================================
  const animationObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ut-animate');
          animationObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  );

  document.querySelectorAll('.ut-product-card, .ut-trust-item, .ut-location-card').forEach(el => {
    animationObserver.observe(el);
  });

  // =============================================
  // Search Overlay
  // =============================================
  window.toggleSearch = function() {
    const existing = document.getElementById('utSearchOverlay');
    if (existing) {
      existing.remove();
      document.body.style.overflow = '';
      return;
    }

    const overlay = document.createElement('div');
    overlay.id = 'utSearchOverlay';
    overlay.style.cssText = `
      position: fixed; inset: 0; background: rgba(0,0,0,0.9);
      z-index: 5000; display: flex; align-items: flex-start;
      justify-content: center; padding-top: 20vh;
      animation: ut-fadeIn 0.2s ease;
    `;
    overlay.innerHTML = `
      <div style="width: 90%; max-width: 600px;">
        <form action="/search" method="get" style="position: relative;">
          <input type="text" name="q" placeholder="Search products..."
            style="
              width: 100%; padding: 20px 60px 20px 24px;
              background: #1a1a1a; border: 2px solid #333;
              border-radius: 12px; color: #fff; font-size: 1.2rem;
              font-family: var(--ut-font-body);
            "
            autofocus
          >
          <button type="submit" style="
            position: absolute; right: 16px; top: 50%;
            transform: translateY(-50%); background: none;
            border: none; color: #e63946; cursor: pointer;
          ">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </form>
        <p style="text-align: center; color: #666; margin-top: 16px; font-size: 0.85rem;">
          Popular: Cropped Tees, Sets, Hoodies, Hats
        </p>
      </div>
    `;

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) toggleSearch();
    });

    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        toggleSearch();
        document.removeEventListener('keydown', escHandler);
      }
    });

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  };

  // =============================================
  // Quick Add to Cart
  // =============================================
  document.querySelectorAll('.ut-product-card form').forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const btn = this.querySelector('button');
      const originalText = btn.textContent;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const formData = new FormData(this);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          btn.textContent = 'Added!';
          btn.style.background = '#e63946';

          // Update cart count
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          const cartCount = document.querySelector('.ut-header__cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          } else {
            const cartBtn = document.querySelector('[aria-label^="Cart"]');
            if (cartBtn) {
              const badge = document.createElement('span');
              badge.className = 'ut-header__cart-count';
              badge.textContent = cart.item_count;
              cartBtn.appendChild(badge);
            }
          }

          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
            btn.style.background = '';
          }, 2000);
        }
      } catch (err) {
        btn.textContent = 'Error';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      }
    });
  });

  // =============================================
  // Wishlist (Local Storage)
  // =============================================
  document.querySelectorAll('.ut-product-card__wishlist').forEach(btn => {
    const productId = btn.dataset.productId;
    const wishlist = JSON.parse(localStorage.getItem('ut_wishlist') || '[]');

    if (wishlist.includes(productId)) {
      btn.querySelector('svg').setAttribute('fill', '#ff3333');
      btn.querySelector('svg').setAttribute('stroke', '#ff3333');
    }

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const wishlist = JSON.parse(localStorage.getItem('ut_wishlist') || '[]');
      const svg = this.querySelector('svg');

      if (wishlist.includes(productId)) {
        // Remove from wishlist
        const index = wishlist.indexOf(productId);
        wishlist.splice(index, 1);
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
      } else {
        // Add to wishlist
        wishlist.push(productId);
        svg.setAttribute('fill', '#ff3333');
        svg.setAttribute('stroke', '#ff3333');

        // Pulse animation
        this.style.transform = 'scale(1.3)';
        setTimeout(() => this.style.transform = '', 200);
      }

      localStorage.setItem('ut_wishlist', JSON.stringify(wishlist));
    });
  });

  // =============================================
  // Conversion Tracking Helpers
  // =============================================
  const UTTracking = {
    trackProductView(productId, productTitle) {
      const viewed = JSON.parse(sessionStorage.getItem('ut_viewed') || '[]');
      if (!viewed.includes(productId)) {
        viewed.push(productId);
        sessionStorage.setItem('ut_viewed', JSON.stringify(viewed));
      }
    },

    trackAddToCart(productId, price) {
      // Can integrate with Google Analytics, Facebook Pixel, etc.
      if (typeof gtag === 'function') {
        gtag('event', 'add_to_cart', {
          currency: 'USD',
          value: price
        });
      }
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_ids: [productId],
          content_type: 'product',
          value: price,
          currency: 'USD'
        });
      }
    }
  };

  window.UTTracking = UTTracking;

  // =============================================
  // Product Page - Image Gallery
  // =============================================
  const mainImg = document.getElementById('utProductImg');
  if (mainImg) {
    document.querySelectorAll('.ut-product__thumb').forEach(thumb => {
      thumb.addEventListener('click', function() {
        const url = this.dataset.imageUrl;
        if (url) {
          mainImg.src = url;
          document.querySelectorAll('.ut-product__thumb').forEach(t => t.classList.remove('ut-product__thumb--active'));
          this.classList.add('ut-product__thumb--active');
        }
      });
    });
  }

  // =============================================
  // Product Page - Variant Selector
  // =============================================
  const productJSON = document.getElementById('utProductJSON');
  if (productJSON) {
    try {
      const product = JSON.parse(productJSON.textContent);
      const variantSelect = document.getElementById('utVariantSelect');
      const priceEl = document.getElementById('utProductPrice');
      const compareEl = document.getElementById('utComparePrice');
      const saveBadge = document.getElementById('utSaveBadge');
      const addBtn = document.getElementById('utAddToCart');
      const selectedOptions = {};

      // Init selected options
      product.options.forEach((opt, i) => {
        const activeBtn = document.querySelector('.ut-product__option-btn--active[data-option-index="' + i + '"]');
        if (activeBtn) selectedOptions[i] = activeBtn.dataset.optionValue;
      });

      // Option button clicks
      document.querySelectorAll('.ut-product__option-btn').forEach(btn => {
        btn.addEventListener('click', function() {
          const idx = parseInt(this.dataset.optionIndex);
          const val = this.dataset.optionValue;
          const name = this.dataset.optionName;

          selectedOptions[idx] = val;

          // Update active state
          this.closest('.ut-product__option-values').querySelectorAll('.ut-product__option-btn').forEach(b => {
            b.classList.remove('ut-product__option-btn--active');
          });
          this.classList.add('ut-product__option-btn--active');

          // Update label
          const label = document.getElementById('utSelected-' + name.toLowerCase().replace(/\s+/g, '-'));
          if (label) label.textContent = val;

          // Find matching variant
          const match = product.variants.find(v => {
            return product.options.every((opt, i) => {
              return v.options[i] === selectedOptions[i];
            });
          });

          if (match && variantSelect) {
            variantSelect.value = match.id;

            // Update price
            if (priceEl) {
              priceEl.textContent = '$' + (match.price / 100).toFixed(2);
            }

            // Update compare price
            if (match.compare_at_price && match.compare_at_price > match.price) {
              if (compareEl) {
                compareEl.textContent = '$' + (match.compare_at_price / 100).toFixed(2);
                compareEl.style.display = '';
              }
              if (saveBadge) {
                var disc = Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100);
                saveBadge.textContent = 'Save ' + disc + '%';
                saveBadge.style.display = '';
              }
              if (priceEl) priceEl.classList.add('ut-product__price--sale');
            } else {
              if (compareEl) compareEl.style.display = 'none';
              if (saveBadge) saveBadge.style.display = 'none';
              if (priceEl) priceEl.classList.remove('ut-product__price--sale');
            }

            // Update availability
            if (addBtn) {
              if (match.available) {
                addBtn.disabled = false;
                addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold Out';
              }
            }

            // Update URL without reload
            var url = new URL(window.location);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url);
          }
        });
      });
    } catch (e) {
      // Product JSON parse error - silent fail
    }
  }

  // =============================================
  // Product Page - Quantity Controls
  // =============================================
  const qtyInput = document.getElementById('utQtyInput');
  const qtyMinus = document.getElementById('utQtyMinus');
  const qtyPlus = document.getElementById('utQtyPlus');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val < 10) qtyInput.value = val + 1;
    });
  }

  // =============================================
  // Product Page - Tabs
  // =============================================
  document.querySelectorAll('.ut-product__tab-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      var tab = this.dataset.tab;

      // Toggle active button
      document.querySelectorAll('.ut-product__tab-btn').forEach(b => b.classList.remove('ut-product__tab-btn--active'));
      this.classList.add('ut-product__tab-btn--active');

      // Toggle content
      document.querySelectorAll('.ut-product__tab-content').forEach(c => c.style.display = 'none');
      var content = document.getElementById('tab-' + tab);
      if (content) content.style.display = 'block';
    });
  });

  // =============================================
  // Product Page - Add to Cart (AJAX)
  // =============================================
  const productForm = document.getElementById('utProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      // Only intercept the add-to-cart, not buy-now
      if (e.submitter && e.submitter.name === 'checkout') return;

      e.preventDefault();
      const btn = document.getElementById('utAddToCart');
      if (!btn) return;

      var origHTML = btn.innerHTML;
      btn.innerHTML = 'Adding...';
      btn.disabled = true;

      try {
        var formData = new FormData(this);
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> Added!';
          btn.style.background = '#4caf50';

          // Update cart count
          var cartRes = await fetch('/cart.js');
          var cart = await cartRes.json();
          var cartCount = document.querySelector('.ut-header__cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          } else {
            var cartBtn = document.querySelector('[aria-label^="Cart"]');
            if (cartBtn) {
              var badge = document.createElement('span');
              badge.className = 'ut-header__cart-count';
              badge.textContent = cart.item_count;
              cartBtn.appendChild(badge);
            }
          }

          setTimeout(function() {
            btn.innerHTML = origHTML;
            btn.disabled = false;
            btn.style.background = '';
          }, 2000);
        }
      } catch (err) {
        btn.textContent = 'Error - Try Again';
        setTimeout(function() {
          btn.innerHTML = origHTML;
          btn.disabled = false;
        }, 2000);
      }
    });
  }

  // =============================================
  // Product Page - Wishlist Button
  // =============================================
  const prodWishBtn = document.querySelector('.ut-product__wishlist-btn');
  if (prodWishBtn) {
    var pid = prodWishBtn.dataset.productId;
    var wl = JSON.parse(localStorage.getItem('ut_wishlist') || '[]');
    if (wl.includes(pid)) {
      prodWishBtn.querySelector('svg').setAttribute('fill', '#ff3333');
      prodWishBtn.querySelector('svg').setAttribute('stroke', '#ff3333');
    }

    prodWishBtn.addEventListener('click', function() {
      var wl = JSON.parse(localStorage.getItem('ut_wishlist') || '[]');
      var svg = this.querySelector('svg');
      if (wl.includes(pid)) {
        wl.splice(wl.indexOf(pid), 1);
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
      } else {
        wl.push(pid);
        svg.setAttribute('fill', '#ff3333');
        svg.setAttribute('stroke', '#ff3333');
        this.style.transform = 'scale(1.2)';
        setTimeout(function() { prodWishBtn.style.transform = ''; }, 200);
      }
      localStorage.setItem('ut_wishlist', JSON.stringify(wl));
    });
  }

  // =============================================
  // Collection Page - Filter System
  // =============================================
  var productGrid = document.getElementById('utProductGrid');
  if (productGrid) {
    var allCards = Array.from(productGrid.querySelectorAll('.ut-product-card'));
    var noResults = document.getElementById('utNoResults');
    var clearBtn = document.getElementById('utClearFilters');
    var activeFiltersEl = document.getElementById('utActiveFilters');
    var filterCountEl = document.getElementById('utFilterCount');

    // Toggle filter groups
    document.querySelectorAll('.ut-filter-group__toggle').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        this.classList.toggle('active');
        var body = this.nextElementSibling;
        body.style.display = body.style.display === 'none' ? 'flex' : 'none';
      });
    });

    // Mobile filter toggle
    var filterToggle = document.getElementById('utFilterToggle');
    var filtersPanel = document.getElementById('utFilters');
    if (filterToggle && filtersPanel) {
      filterToggle.addEventListener('click', function() {
        filtersPanel.classList.toggle('ut-filters--open');
        document.body.style.overflow = filtersPanel.classList.contains('ut-filters--open') ? 'hidden' : '';
      });
    }

    // Filter logic
    function applyFilters() {
      var priceFilters = [];
      var sizeFilters = [];
      var vendorFilters = [];
      var availFilters = [];

      document.querySelectorAll('[data-filter-type="price"]:checked').forEach(function(cb) {
        priceFilters.push({ min: parseInt(cb.dataset.filterMin), max: parseInt(cb.dataset.filterMax) });
      });
      document.querySelectorAll('[data-filter-type="size"]:checked').forEach(function(cb) {
        sizeFilters.push(cb.dataset.filterValue);
      });
      document.querySelectorAll('[data-filter-type="vendor"]:checked').forEach(function(cb) {
        vendorFilters.push(cb.dataset.filterValue);
      });
      document.querySelectorAll('[data-filter-type="available"]:checked').forEach(function(cb) {
        availFilters.push(cb.dataset.filterValue);
      });

      var hasFilters = priceFilters.length || sizeFilters.length || vendorFilters.length || availFilters.length;
      var visibleCount = 0;

      allCards.forEach(function(card) {
        var price = parseInt(card.dataset.productPrice) || 0;
        var vendor = card.dataset.productVendor || '';
        var available = card.dataset.productAvailable || 'true';
        var sizes = (card.dataset.productSizes || '').split(',');

        var show = true;

        if (priceFilters.length) {
          show = priceFilters.some(function(f) { return price >= f.min && price < f.max; });
        }
        if (show && sizeFilters.length) {
          show = sizeFilters.some(function(s) { return sizes.indexOf(s) !== -1; });
        }
        if (show && vendorFilters.length) {
          show = vendorFilters.indexOf(vendor) !== -1;
        }
        if (show && availFilters.length) {
          show = availFilters.indexOf(available) !== -1;
        }

        card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });

      if (noResults) noResults.style.display = visibleCount === 0 ? 'block' : 'none';
      if (clearBtn) clearBtn.style.display = hasFilters ? 'inline' : 'none';
      if (filterCountEl) {
        var totalFilters = priceFilters.length + sizeFilters.length + vendorFilters.length + availFilters.length;
        filterCountEl.textContent = totalFilters;
        filterCountEl.style.display = totalFilters > 0 ? 'inline-flex' : 'none';
      }

      // Update active filter tags
      if (activeFiltersEl) {
        activeFiltersEl.innerHTML = '';
        document.querySelectorAll('.ut-filters input:checked').forEach(function(cb) {
          var label = cb.parentElement.textContent.trim();
          var tag = document.createElement('span');
          tag.className = 'ut-active-filter-tag';
          tag.innerHTML = label + ' &times;';
          tag.addEventListener('click', function() {
            cb.checked = false;
            applyFilters();
          });
          activeFiltersEl.appendChild(tag);
        });
      }
    }

    // Listen to checkbox changes
    document.querySelectorAll('.ut-filters input[type="checkbox"]').forEach(function(cb) {
      cb.addEventListener('change', applyFilters);
    });

    // Clear all
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        document.querySelectorAll('.ut-filters input:checked').forEach(function(cb) { cb.checked = false; });
        applyFilters();
      });
    }
  }

})();
